<template>
  <div v-if="visible" class="modal-overlay" @click.self="close" data-modal="details-recurrence">
    <div class="modal" @click.stop>
      <div class="modal-header">
        <h2>Detalhes do Pix Agendado recorrente</h2>
        <button class="close-button" @click="close">×</button>
      </div>

      <p class="modal-subtitle">
        Confira a sequência de agendamentos de transferências Pix no valor de
        <strong>R$ {{ formatAmount(recurrence.amount) }}</strong> para
        <strong>{{ recurrence.accountDestinationName }}</strong> ({{ recurrence.accountDestinationTaxDocument }})
      </p>

      <table class="recurrence-table">
        <thead>
          <tr>
            <th>Parcela</th>
            <th>Data e hora</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in schedule" :key="index">
            <td>{{ item.parcela }}</td>
            <td class="date-time-cell">
              <div>{{ item.data }}</div>
              <div>{{ item.hora }}</div>
            </td>
            <td>
              <span :class="['status-tag', item.status.toLowerCase()]">
                {{ item.status }}
              </span>
            </td>
            <td> <button
                v-if="item.status === 'Enviado'"
                class="btn btn-link btn-sm p-0 text-primary"
                @click="openReceiptModal(item)"
                title="Ver Comprovante"
              >
                <i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <PixRecurringDetailsModal
        v-if="selectedReceiptData"
        :pixDetail="selectedReceiptData"
        @close="selectedReceiptData = null"
      />
      </div>
  </div>
</template>

<script>
import PixRecurringDetailsModal from '../transactions/PixRecurringDetailsModal.vue';

export default {
  name: 'AppDetailsRecurrence',

  components: {
    PixRecurringDetailsModal,
  },

  props: {
    recurrence: {
      type: Object,
      default: () => ({
        amount: 0,
        accountDestinationName: 'N/A',
        accountDestinationTaxDocument: 'N/A',
        totalTransferred: 0,
        repetitions: 0,
        startDate: null,
        endDate: null,
        frequency: 'daily',
      }),
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedReceiptData: null,
    };
  },

  computed: {
    schedule() {
      if (!this.recurrence.repetitions || !this.recurrence.startDate) {
        return [];
      }

      const schedule = [];
      const startDate = new Date(this.recurrence.startDate);
      const totalTransferred = this.recurrence.totalTransferred || 0;
      const frequency = this.recurrence.frequency || 'daily';

      for (let i = 0; i < this.recurrence.repetitions; i++) {
        const currentDate = new Date(startDate);

        this.addFrequencyToDate(currentDate, i, frequency);

        const isTransferred = i < totalTransferred;
        const status = isTransferred ? 'Enviado' : 'Pendente';

        schedule.push({
          parcela: `${i + 1} de ${this.recurrence.repetitions}`,
          data: this.formatDate(currentDate),
          hora: isTransferred ? this.formatTime(currentDate) : '--',
          status: status,
          scheduledFor: currentDate.toISOString(),
          sentAt: new Date().toISOString(),
        });
      }

      return schedule;
    },
  },

  methods: {
    close() {
      this.selectedReceiptData = null;
      this.$emit('close');
    },
    formatAmount(amount) {
      if (!amount) return '0,00';
      return amount.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatDate(date) {
      if (!date) return '--';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    formatTime(date) {
      if (!date) return '--';
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    },
    addFrequencyToDate(date, multiplier, frequency) {
      switch (frequency.toLowerCase()) {
        case 'weekly':
          date.setDate(date.getDate() + (multiplier * 7));
          break;
        case 'biweekly':
          date.setDate(date.getDate() + (multiplier * 14));
          break;
        case 'monthly':
          date.setMonth(date.getMonth() + multiplier);
          break;
        case 'quarterly':
          date.setMonth(date.getMonth() + (multiplier * 3));
          break;
        case 'sixmonthly':
          date.setMonth(date.getMonth() + (multiplier * 6));
          break;
        case 'yearly':
        case 'annual':
          date.setFullYear(date.getFullYear() + multiplier);
          break;
        default:
          date.setDate(date.getDate() + multiplier);
          break;
      }
    },

    openReceiptModal(item) {
      this.selectedReceiptData = {
        value: this.recurrence.amount,
        status: item.status,
        sentAt: item.sentAt,
        nextTransferDate: item.scheduledFor,
        fee: 0.00,
        totalDebited: this.recurrence.amount,
        message: `Comprovante da ${item.parcela} do Pix Recorrente.`,
        origin: {
          name: 'Nome da Origem',
          agency: '0001',
          account: '123456-7',
          document: '12345678901',
        },
        destination: {
          name: this.recurrence.accountDestinationName,
          agency: '9999',
          account: '987654-3',
          document: this.recurrence.accountDestinationTaxDocument,
        },
      };
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background: rgba(0, 0, 0, 0.5) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 99999 !important;
}

.modal {
  background: white !important;
  border-radius: 12px;
  padding: 24px;
  width: 600px;
  max-width: 90%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  position: relative !important;
  z-index: 100000 !important;
}

.modal-header {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.modal-subtitle {
  margin-top: 12px;
  font-size: 14px;
  color: #555;
}

.recurrence-table {
  width: 100%;
  margin-top: 24px;
  border-collapse: collapse;
  font-size: 14px;
}

.recurrence-table thead {
  background: #f5f5f5;
}

.recurrence-table th,
.recurrence-table td {
  padding: 12px;
  text-align: left;
}

.recurrence-table td {
  border-bottom: 1px solid #eee;
}

.status-tag {
  padding: 4px 12px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 13px;
}

.status-tag.enviado {
  background-color: #d4f5d4;
  color: #217a3c;
}

.status-tag.pendente {
  background-color: #fff4cd;
  color: #8a6d00;
}

.date-time-cell {
  line-height: 1.4;
}

.date-time-cell div:first-child {
  font-weight: 500;
}

.date-time-cell div:last-child {
  font-size: 12px;
  color: #666;
}

.modal-overlay[data-modal="details-recurrence"] {
  display: flex !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.modal-overlay[data-modal="details-recurrence"] .modal {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}
</style>
